export const GET_USER_DTR_SUMMARY = "GET_USER_DTR_SUMMARY";
export const GET_ERRORS = "GET_ERRORS";
export const LOGIN_USER = "LOGIN_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOG_OUT_USER = "LOG_OUT_USER";
export const GET_TABLES = "GET_TABLES";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_TABLE = "SET_TABLE";
export const ADD_ORDER = "ADD_ORDER";
export const CLEAR_ORDERS = "CLEAR_ORDERS";
export const INCREMENT_ORDER = "INCREMENT_ORDER";
export const SET_ORDER_QUANTITY = "SET_ORDER_QUANTITY";
export const TRANSFER_TABLE = "TRANSFER_TABLE";
export const CANCEL_ORDERS = "CANCEL_ORDERS";
export const APPLY_SUMMARY = "APPLY_SUMMARY";
export const PROCESS_SALE = "PROCESS_SALE";
export const CLEAR_CHANGE = "CLEAR_CHANGE";
export const GET_PRODUCTS_FROM_CATEGORY = "GET_PRODUCTS_FROM_CATEGORY";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const ADD_GIFT_CHECK = "ADD_GIFT_CHECK";
export const UPDATE_TABLE = "UPDATE_TABLE";
export const SELECT_ORDER = "SELECT_ORDER";
export const UPDATE_SELECTED_ORDER_QUANTITY = "UPDATE_SELECTED_ORDER_QUANTITY";
export const SET_MANUAL_DISCOUNT = "SET_MANUAL_DISCOUNT";
export const RESET = "RESET";
export const SET_TIEUP = "SET_TIEUP";
export const REMOVE_TIEUP = "REMOVE_TIEUP";
export const SET_CUSTOMER = "SET_CUSTOMER";
export const REMOVE_CUSTOMER = "REMOVE_CUSTOMER";
export const ITEM = "ITEM";
